import { getLogger } from '@/logging/logger';
import { NextApiRequest } from 'next';


export enum httpMethods {
	GET = 'GET',
	POST = 'POST',
	PATCH = 'PATCH',
	PUT = 'PUT',
}

export const buildClearChoiceHeaders = (req: NextApiRequest, contentUtf8 = true) => {
	let hasIpBasedCoordinates = false;
	let coordinates = { latitude: 0, longitude: 0 };
	if (req.headers['cloudfront-viewer-latitude'] && req.headers['cloudfront-viewer-longitude']) {
		hasIpBasedCoordinates = true;
		coordinates = {
			latitude: parseFloat(req.headers['cloudfront-viewer-latitude'] as string),
			longitude: parseFloat(req.headers['cloudfront-viewer-longitude'] as string),
		};
	}

	const clientIp = req?.headers['cloudfront-viewer-address']
		? (req?.headers['cloudfront-viewer-address'] as string)
		: req.connection.remoteAddress;

	if (clientIp || hasIpBasedCoordinates) {
		console.info(`ClientIP: ${clientIp}, Coordinates: ${coordinates.latitude}, ${coordinates.longitude}`);
	}
	return {
		'Content-Type': `application/json${contentUtf8 ? ' ; charset=utf-8' : ''}`,
		'X-Api-Sig': process.env.APP_NAME,
		'X-Api-Key': process.env.CLEARCHOICE_API_KEY,
		'X-Client-IP': clientIp ? clientIp : '',
		'X-Client-LatLng': hasIpBasedCoordinates ? `${coordinates.latitude},${coordinates.longitude}` : '',
		'X-Session-ID': req?.headers['x-session-id'] ? (req?.headers['x-session-id'] as string) : 'N/A',
	};
};

export const parseResponse = async (response: Response, requestMessage: string) => {
	const clonedResponse = response.clone();
	try {
		const parsedResult = await response.json();
		return parsedResult;
	} catch (e) {
		if (clonedResponse?.text) {
			const textResult = await clonedResponse.text();
			throw new Error(`ERROR: ${requestMessage} could not be serialized properly: ${textResult} `);
		}
		throw new Error(`ERROR: ${requestMessage} could not read response ${e}`);
	}
};

/**
 *
 * by default the legacy API URL is returned that calls legacy (Apollo) API.  First checks
 * request headers to see if new API version is requested (Hydra). Ultimately determines
 * what endpoint to call for CC web-api.
 */
export const determineBaseURL = (req: NextApiRequest): string => {
	try {
		const USE_HYDRA = !!(req?.headers?.hydra && req?.headers?.hydra === 'ON');
		return USE_HYDRA ? process.env.CLEARCHOICE_HYDRA_API_URL || '' : process.env.CLEARCHOICE_API_URL || '';
	} catch (e) {
		const logger = getLogger('app');
		logger.error({ message: 'determineBaseURL() failed' });
		return ''
	}
};
